/**
 * Chat model IDs shown in the UI — keep aligned with built-in `models` in
 * `Python-Script/AIRA/services/llm_config.py` (AIRA_LLM_CONFIG JSON merges on top).
 */
export const CHAT_MODEL_GPT4O = 'gpt-4o'
export const CHAT_MODEL_GPT5 = 'gpt-5-2025-08-07'
export const CHAT_MODEL_GEMINI_25_PRO = 'gemini-2.5-pro'
export const CHAT_MODEL_CLAUDE_SONNET_45 = 'claude-sonnet-4.5'
export const CHAT_MODEL_CLAUDE_SONNET_45_SKILLS = 'claude-sonnet-4.5-skills'

export type LlmConfigChatModelOption = { id: string; label: string }

/** Order matches insertion order of built-in models in llm_config.py */
export const LLM_CONFIG_CHAT_MODELS: readonly LlmConfigChatModelOption[] = [
  { id: CHAT_MODEL_GPT4O, label: 'GPT-4o' },
  { id: CHAT_MODEL_GPT5, label: 'GPT-5' },
  { id: CHAT_MODEL_GEMINI_25_PRO, label: 'Gemini 2.5 Pro' },
  { id: CHAT_MODEL_CLAUDE_SONNET_45, label: 'Claude Sonnet 4.5' },
  { id: CHAT_MODEL_CLAUDE_SONNET_45_SKILLS, label: 'Claude Sonnet 4.5 (Skills)' },
] as const

export const DEFAULT_CHAT_MODEL_ID = CHAT_MODEL_GPT4O

const _allowedIds = new Set(LLM_CONFIG_CHAT_MODELS.map((m) => m.id))

export function isLlmConfigChatModelId(id: string | null | undefined): id is string {
  return Boolean(id && _allowedIds.has(id))
}
